import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Drives/Components/DriveTable/Drivefilter/Style/style'
import React from 'react'
const DriveRoleFilter = ({ driveStatus, setDrivestatus }) => {
  const statusOptions = [
    {
      label: 'Invited',
      value: 'INVITED',
    },
    {
      label: 'Started',
      value: 'STARTED',
    },
    {
      label: 'Completed',
      value: 'COMPLETED',
    },
    {
      label: 'Absent',
      value: 'ABSENT',
    },
    {
      label: 'Qualified',
      value: 'ISQUALIFIED',
    },
  ]
  const onChange = values => {
    const updatedStatus = driveStatus?.filter(value => values.includes(value))

    values.forEach(value => {
      if (!updatedStatus.includes(value)) {
        updatedStatus.push(value)
      }
    })
    setDrivestatus(updatedStatus)
  }
  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={driveStatus}
        options={statusOptions}
        onChange={onChange}
      />
    </Wrapper>
  )
}

export default DriveRoleFilter
